// extracted by mini-css-extract-plugin
export default {"wrapper":"ReturnButton__wrapper___mmqgz","modal":"ReturnButton__modal___l47o2","button":"ReturnButton__button___G35NI","arrow":"ReturnButton__arrow___Ga_s5"};